<scip-search-container
  [recentSearchType]="recentSearchEnum.Products"
  [quickSearchConfiguration]="multiInputConfigurationQuickSearch"
  [advancedSearchConfiguration]="multiInputConfigurationAdvSearch"
  [headerText]="translationKeys.productComponent.html.findProducts | translate"
  [useTwoColumns]="true"
  [autoCollapseHeight]="833"
></scip-search-container>
